module.exports = __webpack_public_path__ + "img/icon_button_bg.5c640c8e.png";